import { PURCHASE_ORDER_LIST_SUCCESS, PURCHASE_ORDER_PAY_BATCH_LIST_SUCCESS } from "../constants";

const initialState = {
  list: [],
  batchList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case PURCHASE_ORDER_LIST_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  case PURCHASE_ORDER_PAY_BATCH_LIST_SUCCESS:
    return {
      ...state,
      batchList: action.payload
    };
  default:
    return state;
  }
}